const HeaderWithIcon = ({ icon, children }) => {
    return (
        <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className='colored-square'>
                <i className={icon} style={{ fontSize: "x-large" }}></i>
            </div>
            <div className='ms-3'>
                <h4 data-testid="ticket-view-title" className='m-0'>
                    {children}
                </h4>
            </div>
        </div>
        <hr className="heading mt-3"></hr>
        </>
    );
};

export default HeaderWithIcon;
